import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Snackbar from './features/snack-bar/SnackBar'
import Error404 from './pages/errors/Error404'
import routeBuilder from './routes/route-builder'
import { ROUTES } from './routes/routes' //Complete routes array
/**
 * Builds the route components from the routes object
 */
const routes = routeBuilder({ routes: ROUTES })

function App() {
  return (
    <div className="App ">
      <Routes>
        <Route path="*" element={<Error404 />} />
        {routes}
      </Routes>
      <Snackbar />
    </div>
  )
}

export default App
